import styles from "./NoDataPoints.module.scss";

export default function NoDataPoints() {
  return (
    <div className={styles.NoDataPoints}>
      <svg
        width="24"
        height="16"
        viewBox="0 0 24 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.375 11.1731C1.28568 11.657 0 12.3162 0 13.0427C0 14.5278 5.37258 15.7317 12 15.7317C18.6274 15.7317 24 14.5278 24 13.0427C24 12.3162 22.7143 11.657 20.625 11.1731V12.3453C20.625 13.1609 20.13 13.8293 19.5188 13.8293H4.48125C3.87 13.8293 3.375 13.1605 3.375 12.3453V11.1731Z"
          fill="black"
          fillOpacity="0.04"
        />
        <path
          d="M15.6049 6.50411C15.6049 5.88755 15.9776 5.37856 16.44 5.37817H20.625V12.3454C20.625 13.161 20.13 13.8294 19.5187 13.8294H4.48125C3.87 13.8294 3.375 13.1606 3.375 12.3454V5.37817H7.56C8.02238 5.37817 8.39512 5.8864 8.39512 6.50295V6.51141C8.39512 7.12796 8.772 7.62581 9.234 7.62581H14.766C15.228 7.62581 15.6049 7.12335 15.6049 6.5068V6.50411Z"
          fill="black"
          fillOpacity="0.04"
          stroke="black"
          strokeOpacity="0.15"
        />
        <path
          d="M20.625 5.42051L16.8203 1.00205C16.6376 0.700884 16.371 0.518799 16.0901 0.518799H7.90988C7.629 0.518799 7.36237 0.700884 7.17975 1.00167L3.375 5.42089"
          stroke="black"
          strokeOpacity="0.15"
        />
      </svg>
      No datapoints
    </div>
  );
}
